import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import urlJoin from 'url-join';
import { SettingsService } from '../shared/services/settings/settings.service';
import { ActionHistory } from './action-history.model';
import { map } from 'rxjs/operators';
import { ROUTE_TOKEN_GATEWAY_URL } from '../shared/interceptors/gateway-url.interceptor';

@Injectable()
export class ActionHistoryService {

  constructor(
    private readonly http: HttpClient,
    private readonly settings: SettingsService) { }


  getActionHistory(payIds: string[]): Observable<ActionHistory[]> {
    const url = this._getUri('pays/actions/history', this.settings.tenantId);
    return this.http.get<ActionHistory[]>(url + '?payIds=' + payIds.join('&payIds='))
      .pipe(
        map(rawEvents => rawEvents.map(rawEvent => ActionHistory.fromRawEvent(rawEvent)))
      );
  }

  private _getUri(path: string, tenantId: string) {
    return urlJoin(ROUTE_TOKEN_GATEWAY_URL, `cui-payment/v1/tenants/${encodeURI(tenantId)}`, path);
  }

}
